import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { findDOMNode } from 'react-dom'
import { DragSource, DropTarget } from 'react-dnd'
import classnames from 'classnames'
import Moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import ImmutableProptypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import Dropdown from 'rc-dropdown'
import Menu, { Item as MenuItem, Divider } from 'rc-menu'
import 'rc-dropdown/assets/index.css'
import ReactTooltip from 'react-tooltip'

import Icon from '_components/icon'

import styles from './styles.css'

momentDurationFormatSetup(Moment)

const mapStateToProps = ({ counter, currentTask, settings }) => ({
  counter,
  currentTask,
  settings,
})

class Card extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    order: PropTypes.number.isRequired,
    section: PropTypes.number.isRequired,
    checkCard: PropTypes.func.isRequired,
    shiftCard: PropTypes.func.isRequired,
    deleteCard: PropTypes.func.isRequired,
    moveToSectionCard: PropTypes.func.isRequired,
    createCalendarCard: PropTypes.func.isRequired,
    pressTasksCard: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  onDeleteClick = () => {
    const { deleteCard, id } = this.props
    deleteCard(id)
  }

  onShiftClick = () => {
    const { shiftCard, id, name, section } = this.props
    shiftCard(id, name, section)
  }

  onCheckboxClick = () => {
    const { checkCard, name, id } = this.props
    checkCard(name, id)
  }

  onMoveToSectionClick = sectionId => {
    const { moveToSectionCard, id, name, order } = this.props
    moveToSectionCard(id, name, order, sectionId)
  }

  onCreateCalendarClick = () => {
    const { createCalendarCard, name } = this.props
    createCalendarCard(name)
  }

  onCardClick = () => {
    const { pressTasksCard, id } = this.props
    pressTasksCard(id)
  }

  handleClick = ({ key }) => {
    switch (key) {
      case '1':
        this.onDeleteClick()
        break
      case '2':
        this.onMoveToSectionClick(0)
        break
      case '3':
        this.onMoveToSectionClick(100)
        break
      case '4':
        this.onMoveToSectionClick(200)
        break
      case '5':
        this.onMoveToSectionClick(300)
        break
      case '6':
        this.onMoveToSectionClick(400)
        break
      case '7':
        this.onCreateCalendarClick()
        break
      default:
    }
    return null
  }

  menu = () => {
    const { section } = this.props
    return (
      <Menu onClick={this.handleClick} selectable={false}>
        <MenuItem key="1">Delete</MenuItem>
        {section !== 0 && (
          <MenuItem key="2">
            Move to {this.props.settings.get('tomorrowSection0') || 'Recurring'}
          </MenuItem>
        )}
        {section !== 100 && (
          <MenuItem key="3">
            Move to {this.props.settings.get('tomorrowSection1') || 'Tomorrow'}
          </MenuItem>
        )}
        {section !== 200 && (
          <MenuItem key="4">
            Move to {this.props.settings.get('tomorrowSection2') || 'Later'}
          </MenuItem>
        )}
        {section !== 300 && (
          <MenuItem key="5">
            Move to {this.props.settings.get('tomorrowSection3') || 'Much Later'}
          </MenuItem>
        )}
        {section !== 400 && (
          <MenuItem key="6">
            Move to {this.props.settings.get('tomorrowSection4') || 'Never'}
          </MenuItem>
        )}
        <MenuItem key="7">Add to Calendar</MenuItem>
      </Menu>
    )
  }

  getSectionName = () => {
    const { section } = this.props
    let sectionName
    switch (section) {
      case 0:
        sectionName = 'Recurring'
        break
      case 100:
        sectionName = this.props.settings.get('tomorrowSection1')
        break
      case 200:
        sectionName = this.props.settings.get('tomorrowSection2')
        break
      case 300:
        sectionName = this.props.settings.get('tomorrowSection3')
        break
      case 400:
        sectionName = this.props.settings.get('tomorrowSection4')
        break
      default:
        sectionName = ''
    }
    return sectionName
  }

  renderStatus = () => {
    const { status } = this.props
    let iconName = ''

    switch (status) {
      case 0:
        iconName = 'hmm-icon-square-empty'
        break
      case 1:
        iconName = 'hmm-icon-square-partial'
        break
      case 2:
        iconName = 'hmm-icon-square-check'
        break
      case 3:
        iconName = 'hmm-icon-square-partial'
        break
      case 4:
        iconName = 'hmm-icon-continue'
        break
      default:
        iconName = 'hmm-icon-square-empty'
    }

    return <i onClick={this.onCheckboxClick} className={classnames(`${iconName}`, styles.icon)} />
  }

  render() {
    const { name } = this.props
    const borderColor = 'rgba(150,150,150,0.8)'

    return (
      <div className={classnames(styles.card)} style={{ border: `${borderColor} 3px solid` }}>
        {this.renderStatus()}
        <div
          data-tip
          data-for={`${name}-tip`}
          onClick={this.onCardClick}
          className={classnames(styles.name)}
        >
          {name}
          <ReactTooltip id={`${name}-tip`}>{name}</ReactTooltip>
        </div>
        <div onClick={this.onCardClick} className={classnames(styles.name)}>
          {this.getSectionName()}
        </div>
        <i onClick={this.onShiftClick} className={classnames('fa fa-arrow-up', styles.icon)} />
        <Dropdown trigger={['click']} overlay={this.menu()} animation="slide-up">
          <i className={classnames('fa fa-ellipsis-v', styles.icon)} />
        </Dropdown>
      </div>
    )
  }
}

export default connectRedux(mapStateToProps, null)(Card)



// WEBPACK FOOTER //
// ./src/views/search/tasks-card/index.js